import React from 'react';

import { Button, Group, Modal, Stack, Text, Title } from '@mantine/core';
import useDeleteWorkoutMovement from 'hooks/workoutMovement/useDeleteWorkoutMovement';
import { WorkoutMovementList } from 'types';
import notificationHandler from 'utils/notifications';

const ModalMovementDelete = ({
  opened,
  movement,
  handleClose,
}: {
  opened: boolean;
  handleClose: () => void;
  movement: WorkoutMovementList;
}): JSX.Element => {
  const { mutate, isLoading } = useDeleteWorkoutMovement();
  const { successNotification, errorNotification } = notificationHandler();

  const handleDelete = (): void => {
    mutate(movement.workoutMovementId, {
      onSuccess: () => {
        successNotification('Movement deleted', `${movement.name} has been deleted successfully.`);
      },
      onError: error => {
        const errorMessage = error.response?.data?.message || 'Failed to delete movement';
        errorNotification('Delete failed', errorMessage);
      },
      onSettled: () => {
        handleClose();
      },
    });
  };

  return (
    <Modal
      centered
      opened={opened}
      onClose={handleClose}
      title={<Title order={4}>Delete Movement?</Title>}
      size='auto'
    >
      <Stack>
        <Text>
          Are you sure you want to delete <strong>{movement.name}</strong>?
        </Text>
        <Text color='dimmed'>This action cannot be undone.</Text>
        <Group position='right'>
          <Button variant='subtle' onClick={handleClose}>
            Cancel
          </Button>
          <Button onClick={handleDelete} color='red' loading={isLoading}>
            Delete Permanently
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default ModalMovementDelete;
